import { useContext } from 'react';

import { Button } from '@/components/Shared/ui';
import { useAppDispatch, useAppSelector } from '@/store';
import { onSetSelectedLeasing } from '@/store/financingStep.slice';
import { setCurrent } from '@/store/newOrder.slice';
import type { TAutoCredLeasingResponse } from '@/types/newOrder';

import { OfferStepContext } from '../offer-step';

interface IProps {
  leasingOffer: TAutoCredLeasingResponse;
}

const useLeasingHeaderActions = ({ leasingOffer }: IProps) => {
  const dispatch = useAppDispatch();
  const { onAcceptLeasingOffer } = useContext(OfferStepContext);
  const {
    userAccesses: {
      autoCredit: { canAcceptOffer }
    }
  } = useAppSelector((state) => state.userInfo);
  const { orderApp } = useAppSelector((state) => state.newOrder);
  const { selectedLeasing } = useAppSelector((state) => state.financingStep);

  const canAccept =
    leasingOffer.status.code === 'approved' ||
    leasingOffer.status.code === 'accepted_alternative';
  // Блокируем кнопки "Принять" и "Отклонить", если заявка создана клиентом
  // и текущий leasingOffer не имеет статуса "Принято клиентом"
  const isButtonsDisabled = canAccept && orderApp?.isOnlineRequest;

  const headerActions: React.ReactElement[] = [];
  if (
    leasingOffer.status.code === 'financed' ||
    leasingOffer.status.code === 'waiting_of_financing'
  ) {
    headerActions.push(
      <Button
        key={leasingOffer.uuid + 'continue'}
        size="small"
        variant="filled-red"
        onClick={() => {
          if (!selectedLeasing) dispatch(onSetSelectedLeasing(leasingOffer));
          dispatch(setCurrent(2));
        }}
      >
        Продолжить
      </Button>
    );
  } else if (canAccept || leasingOffer.status.code === 'client_accepted') {
    headerActions.push(
      <Button
        key={leasingOffer.uuid + 'accept'}
        size="small"
        variant="filled-red"
        onClick={() => {
          onAcceptLeasingOffer(leasingOffer);
        }}
        disabled={isButtonsDisabled || !canAcceptOffer}
      >
        Принять <span className="offer-body__hidden">предложение</span>
      </Button>
    );
  }
  return { headerActions };
};

export default useLeasingHeaderActions;
